import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  podcastCard: {
    boxSizing: 'border-box',
    position: 'relative',
    backgroundColor: 'var(--background-color-full)',
    borderRadius: 8,
    display: 'flex !important',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    transition: 'transform 0.3s ease-in-out',
    outline: 'none',
    padding: 10,
    width: 210,
    minHeight: 380,

    [theme.breakpoints.down('sm')]: {
      '&.browseCard': {
        width: 160,
      },
    },
    '& $podcastTitle': {
      color: 'var(--text-color)',
      fontSize: '1rem',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '0.5rem',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxHeight: '3rem',
      minHeight: 48,
      lineHeight: '1.5rem',
      padding: '0 5px',
    },
    '& $podcastRank': {
      fontSize: 52,
      fontWeight: 600,
      color: '#f56100',
      [theme.breakpoints.down('sm')]: {
        fontSize: 32,
      },
    },
    '& $podcastGenre': {
      fontSize: 16,
      fontWeight: 400,
      color: 'var(--podcast-genre-color)',
      fontStyle: 'italic',
    },
    '& $podcastArtist': {
      fontSize: 14,
      fontWeight: 600,
      color: 'var(--text-secondary-color)',
      marginBottom: 5,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '100%',
    },
    '& .scrolling-text': {
      display: 'inline-block',
      minWidth: '100%',
    },
    '& $podcastCountry': {
      fontSize: 14,
      fontWeight: 400,
      color: 'var(--text-secondary-color)',
      marginTop: 5,
    },
    '& $historyRank': {
      boxSizing: 'border-box',
      color: 'var(--text-color)',
      borderRadius: '50%',
      backgroundColor: 'var(--background-color-secondary)',
      width: 65,
      height: 65,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transform: 'scale(0.8) translateX(12px)',
      '& svg': {
        marginLeft: -5,
        marginBottom: 2,
        fontSize: 22,
      },
      '& $historyRankUp': {
        display: 'flex',
        alignItems: 'center',
        fontSize: 26,
        fontWeight: 600,
        color: '#9df500',
        '& svg': {
          fill: '#9df500',
        },
      },
      '& $historyRankDown': {
        display: 'flex',
        alignItems: 'center',
        fontSize: 26,
        fontWeight: 600,
        color: '#f50000',
      },
    },
  },
  podcastImage: {
    width: '100%',
    height: 188,
    borderRadius: 10,
    [theme.breakpoints.down('sm')]: {
      height: 240,

      '&.browseImage': {
        height: 140,
        width: 140,
      },
    },
  },
  podcastIcon: {
    width: 20,
    height: 20,
    marginRight: 5,
    '& path': {
      fill: 'var(--text-color)',
    },
  },
  rankContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    padding: '5px 5px 0',
    boxSizing: 'border-box',
    alignItems: 'center',
    marginTop: 'auto',
  },
  noPodcastsText: {
    color: 'white',
    textAlign: 'center',
    fontSize: '1.2rem',
    marginBottom: '2rem !important',
  },
  podcastImageWrapper: {
    position: 'relative',
    width: '100%',
    marginBottom: 10,
    '&:hover $imageOverlay': {
      opacity: 1,
    },
  },
  imageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    opacity: 0,
    transition: 'opacity 0.5s ease',
    borderRadius: 10,
    '& $overlayButton': {
      color: 'white ',
      fontSize: 14,
      padding: '5px 10px ',
      '&:hover': {
        color: '#46c0ec',
        backgroundColor: 'transparent',
      },
    },
  },
  lightThemeBorder: {
    border: '1px solid var(--border-color)',
  },
  lightThemeBoxShadow: {
    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.4)',
  },
  overlayButton: {},
  podcastRank: {},
  podcastTitle: {},
  podcastGenre: {},
  historyRank: {},
  historyRankUp: {},
  historyRankDown: {},
  podcastCountry: {},
  podcastArtist: {},
  fallbackContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--background-color-secondary)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: 'var(--text-color)',
  },
  fallbackText: {
    fontSize: '2rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
}));
